<template>
  <div style="margin: 15px; margin-right: 30px;">
    <el-form ref="form" :model="form" label-width="180px" :disabled="true">
      <!-- 必填 -->
      <div class="mode_box">
        <div class="card_info">车辆信息</div>
        <el-row style="padding-right: 80px;">
          <el-col :span="8">
            <el-form-item label="车辆牌照号" prop="licenseNumber">
              <el-input
                v-model="form.licenseNumber"
                placeholder="请输入车辆牌照号"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="车牌颜色" prop="vehicleLicenseColor">
              <el-select
                v-model="form.vehicleLicenseColor"
                placeholder="请选择车牌颜色"
                clearable
              >
                <el-option
                  v-for="item in parentData.vehicleLicenseColorList"
                  :key="item.code"
                  :label="item.name"
                  :value="item.code"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="车辆类型" prop="classificationCode">
              <el-select
                v-model="form.classificationCode"
                placeholder="请选择车辆类型"
                clearable
                filterable
              >
                <el-option
                  v-for="item in parentData.vehicleClassificationList"
                  :key="item.code"
                  :label="item.name"
                  :value="item.code"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="车长" prop="carLengthName">
              <el-select
                v-model="form.carLengthName"
                placeholder="请选择车长"
                clearable
                filterable
              >
                <el-option
                  v-for="item in parentData.vehicleLengthList"
                  :key="item.code"
                  :label="item.name"
                  :value="item.code"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              :label="
                form.isHasTrailer == 1 ? '车头整备质量(kg)' : '车辆总质量(kg)'
              "
              prop="totalWeight"
            >
              <el-input
                v-model="form.totalWeight"
                type="number"
                :placeholder="
                  form.isHasTrailer == 1
                    ? '请输入车头整备质量'
                    : '请输入车辆总质量'
                "
                clearable
                @change="value => setkey(value, 'totalWeight')"
              />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="车辆识别代码" prop="vin">
              <el-input
                v-model="form.vin"
                placeholder="请输入车辆识别码VIN"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :span="8" class="remars_wrap m_b_10">
            <el-form-item
              label="车辆道路运输证号"
              prop="roadTransportCertificateNumber"
            >
              <el-input
                v-model="form.roadTransportCertificateNumber"
                placeholder="请输入车辆道路运输证号"
                clearable
                @change="
                  value => {
                    form.roadTransportCertificateNumber = value.replace(
                      /\W/g,
                      ''
                    );
                  }
                "
              />
              <div class="remarks remarks_position">
                注:总质量4.5吨及以下普通货运车辆可填车籍地6位行政区域代码+000000
              </div>
            </el-form-item>
          </el-col>

          <el-col :span="8" class="remars_wrap m_b_10">
            <el-form-item label="车辆行驶证档案编号" prop="vehicleLicense">
              <el-input
                v-model="form.vehicleLicense"
                placeholder="请输入车辆行驶证档案编号"
                clearable
                @change="
                  value => {
                    form.vehicleLicense = value.replace(/\W/g, '');
                  }
                "
              />
              <div class="remarks remarks_position">
                注:行驶证若不存在档案编号可填车籍地6位行政区域代码+000000
              </div>
            </el-form-item>
          </el-col>

          <el-col :span="8" class="m_b_10">
            <el-form-item
              :label="
                form.isHasTrailer == 1 ? '准牵引总质量(kg)' : '核定载质量(kg)'
              "
              prop="loadWeight"
            >
              <el-input
                v-model="form.loadWeight"
                type="number"
                :placeholder="
                  form.isHasTrailer == 1
                    ? '请输入准牵引总质量'
                    : '请输入核定载质量'
                "
                clearable
                @change="value => setkey(value, 'loadWeight')"
              />
            </el-form-item>
          </el-col>
          <el-col v-if="reportProvinceName == 'jiangsu'" :span="8">
            <el-form-item label="车轴数" prop="axlenum">
              <el-input
                v-model="form.axlenum"
                placeholder="请输入车轴数"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="车辆能源类型" prop="vehicleEnergyType">
              <el-select
                v-model="form.vehicleEnergyType"
                placeholder="请选择车辆能源类型"
                clearable
              >
                <el-option
                  v-for="item in parentData.vehicleEnergyTypeList"
                  :key="item.code"
                  :label="item.name"
                  :value="item.code"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              label="车辆行驶证到期日期"
              prop="vehicleLicenseDueDate"
            >
              <el-date-picker
                v-model="form.vehicleLicenseDueDate"
                type="date"
                placeholder="请选择车辆行驶证到期日期"
                value-format="yyyy-MM-dd"
              />
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item label="车辆所有人" prop="owner">
              <el-input
                v-model="form.owner"
                placeholder="请输入车辆所有人"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-col :span="6">
              <el-form-item class="dif" prop="length" label="外廓尺寸">
                <el-input
                  v-model="form.length"
                  placeholder="车辆长度"
                  clearable
                />mm
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-form-item class="dif" prop="width" label-width="10px">
                *
                <el-input
                  v-model="form.width"
                  style="padding-left: 6px;box-sizing: border-box;"
                  placeholder="车辆宽度"
                  clearable
                />mm
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-form-item class="dif" prop="height" label-width="10px">
                *
                <el-input
                  v-model="form.height"
                  style="padding-left: 6px;box-sizing: border-box;"
                  placeholder="车辆高度"
                  clearable
                />mm
              </el-form-item>
            </el-col>
          </el-col>
          <br />
          <el-col v-if="hasTaxOpen" :span="8">
            <el-form-item label="车辆实际所有人" prop="realOwner">
              <el-input
                v-model="form.realOwner"
                placeholder="请输入车辆实际所有人"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col v-if="hasTaxOpen" :span="8">
            <el-form-item label="车辆实际所有人联系方式" prop="realOwnerPhone">
              <el-input
                v-model="form.realOwnerPhone"
                placeholder="请输入车辆实际所有人联系方式"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col v-if="hasTaxOpen" :span="8">
            <el-form-item v-if="hasTaxOpen" label="车辆品牌" prop="brand">
              <el-input
                v-model="form.brand"
                placeholder="请输入车辆品牌"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :span="8" class="remars_wrap m_b_10">
            <el-form-item label="道路运输经营许可证号" prop="roadPermitNumber">
              <el-input
                v-model="form.roadPermitNumber"
                placeholder="请输入道路运输经营许可证号"
                clearable
                @change="
                  value => {
                    form.roadPermitNumber = value.replace(/\W/g, '');
                  }
                "
              />
              <div class="remarks remarks_position">
                注:总质量4.5吨及以下普通货运车辆的可填车籍地6位行政区域代码+000000
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="8" class="m_b_10">
            <el-form-item
              label="道路运输证到期日期"
              prop="roadTransportCertificateDate"
            >
              <el-date-picker
                v-model="form.roadTransportCertificateDate"
                type="date"
                placeholder="请选择道路运输证到期日期"
                value-format="yyyy-MM-dd"
              />
            </el-form-item>
          </el-col>
          <el-col
            v-if="reportProvinceName == 'liaoning'"
            class="m_b_10"
            :span="8"
          >
            <el-form-item
              label="车辆道路运输证字"
              prop="roadTransportCertificateWord"
            >
              <el-input
                v-model="form.roadTransportCertificateWord"
                placeholder="请输入车辆道路运输证字"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :span="8" class="m_b_10">
            <el-form-item label="道路经营许可证业户名称" prop="roadPermitName">
              <el-input
                v-model="form.roadPermitName"
                placeholder="请输入道路经营许可证业户名称"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col v-if="reportProvinceName == 'liaoning'" :span="8">
            <el-form-item
              label="道路经营业户社会信用代码"
              prop="businessUniformSocialCreditCode"
            >
              <el-input
                v-model="form.businessUniformSocialCreditCode"
                placeholder="道路经营业户社会信用代码"
                clearable
                @change="
                  value => {
                    form.businessUniformSocialCreditCode = value.replace(
                      /\W/g,
                      ''
                    );
                  }
                "
              />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="是否挂车" prop="isHasTrailer">
              <el-select
                v-model="form.isHasTrailer"
                placeholder="请选择是否挂车"
                clearable
              >
                <el-option
                  v-for="item in radioOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="是否挂靠车辆" prop="isLinked">
              <el-select
                v-model="form.isLinked"
                placeholder="请选择是否挂靠车辆"
                clearable
              >
                <el-option
                  v-for="item in radioOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row style="padding-right: 80px;">
          <el-col :span="24">
            <el-form-item label="车辆证件" required>
              <ImgReview
                lebal="车辆行驶证正页照片"
                :src="form.vehicleLicenseImg"
                error="未上传"
              />
              <ImgReview
                lebal="车辆行驶证副页照片"
                :src="form.vehicleLicenseDeputyPageImg"
                error="未上传"
              />
              <ImgReview
                lebal="车辆行驶证年审页"
                :src="form.vehicleLicenseSupplementImg"
                error="未上传"
              />

              <ImgReview
                lebal="车辆照片"
                :src="form.vehicleImg"
                error="未上传"
              />

              <ImgReview
                lebal="道路运输证照片"
                :src="form.roadTransportCertificateImg"
                error="未上传"
              />
              <ImgReview
                lebal="道路运输证补充照片"
                :src="form.roadTransportCertificateDeputyImg"
                error="未上传"
              />

              <ImgReview
                lebal="道路运输经营许可证照片"
                :src="form.roadPermitNumberImg"
                error="未上传"
              />
              <ImgReview
                v-if="hasTaxOpen"
                lebal="车主声明"
                :src="form.stateImg"
                error="未上传"
              />
              <ImgReview
                v-if="form.isLinked"
                lebal="挂靠协议照片"
                :src="form.depenDealImg"
                error="未上传"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </div>

      <div class="mode_box">
        <div class="card_info">挂车信息</div>
        <el-row v-if="compTrailer" style="padding-right: 80px;">
          <el-col v-if="compTrailer" :span="8">
            <el-form-item label="挂车车牌号" prop="trailerNum">
              <el-input
                v-model="form.trailerNum"
                placeholder="请输入挂车车牌号"
              />
            </el-form-item>
          </el-col>
          <el-col v-if="compTrailer" :span="8">
            <el-form-item label="挂车车牌颜色" prop="trailerLicenseColorName">
              <el-input
                v-model="form.trailerLicenseColorName"
                placeholder="请输入挂车车牌颜色"
              />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="挂车车辆类型" prop="trailerClassificationCode">
              <el-select
                v-model="form.trailerClassificationCode"
                placeholder="请选择挂车车辆类型"
                clearable
                filterable
              >
                <el-option
                  v-for="item in parentData.vehicleClassificationList"
                  :key="item.code"
                  :label="item.name"
                  :value="item.code"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col v-if="compTrailer" :span="8">
            <el-form-item label="挂车总质量(kg)" prop="trailerTotalWeight">
              <el-input
                v-model="form.trailerTotalWeight"
                placeholder="请输入挂车总质量"
                @change="value => setkey(value, 'trailerTotalWeight')"
              />
            </el-form-item>
          </el-col>
          <el-col v-if="compTrailer" :span="8">
            <el-form-item label="挂车核定载质量(kg)" prop="trailerLoadWeight">
              <el-input
                v-model="form.trailerLoadWeight"
                placeholder="请输入挂车核定载质量"
              />
            </el-form-item>
          </el-col>
          <el-col v-if="compTrailer" :span="8">
            <el-form-item label="挂车道路运输证号" prop="trailerRoadTransport">
              <el-input
                v-model="form.trailerRoadTransport"
                placeholder="请输入挂车道路运输证号"
              />
              <div class="remarks">
                总质量4.5吨及以下普通货运车辆可填车籍地6位行政区代码+000000
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- 总重量<=4.5吨(必填) -->
        <el-row style="padding-right: 80px;">
          <el-col :span="8">
            <el-form-item label="总重量<=4.5吨(必填)">
              <el-switch v-model="showExtra" />
            </el-form-item>
          </el-col>
          <el-col v-if="isCtmsShow" :span="8">
            <el-form-item label="年审时间" prop="annualReviewTime">
              <el-date-picker
                v-model="form.annualReviewTime"
                type="date"
                placeholder="请选择年审时间"
                value-format="yyyy-MM-dd"
                clearable
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :hidden="!showExtra" style="padding-right: 80px;">
          <el-col :span="8">
            <el-form-item label="车辆使用性质" prop="useCharacter">
              <el-input
                v-model="form.useCharacter"
                placeholder="请输入使用性质"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              label="车辆行驶证发证机关"
              prop="issuingOrganizations"
            >
              <el-input
                v-model="form.issuingOrganizations"
                placeholder="请输入车辆行驶证发证机关"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="车辆行驶证注册日期" prop="registerDate">
              <el-date-picker
                v-model="form.registerDate"
                type="date"
                placeholder="请选择车辆行驶证注册日期"
                value-format="yyyy-MM-dd"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="车辆行驶证发证日期" prop="issueDate">
              <el-date-picker
                v-model="form.issueDate"
                type="date"
                placeholder="请选择车辆行驶证发证日期"
                value-format="yyyy-MM-dd"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <!-- 选填 -->
        <el-row style="padding-right: 80px;">
          <el-col :span="24">
            <el-form-item label="非必填项">
              <el-switch v-model="otherItems" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="otherItems" style="padding-right: 80px;">
          <el-col :span="8">
            <el-form-item label="车身自重(kg)" prop="selfRespect">
              <el-input
                v-model="form.selfRespect"
                placeholder="请输入车身自重"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="定位来源" prop="locationSource">
              <el-select
                v-model="form.locationSource"
                placeholder="请选择定位来源"
                clearable
              >
                <el-option
                  v-for="item in parentData.locationSourceList"
                  :key="item.code"
                  :label="item.name"
                  :value="item.code"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row style="padding-right: 80px;">
          <el-col :span="24">
            <el-form-item label="挂车证件" required>
              <ImgReview
                lebal="挂车行驶证正页照片"
                :src="form.trailerVehicleLicenseImg"
                error="未上传"
              />
              <ImgReview
                lebal="挂车行驶证副页照片"
                :src="form.trailerVehicleLicenseDeputyPageImg"
                error="未上传"
              />
              <ImgReview
                lebal="挂车行驶证年审页"
                :src="form.trailerVehicleLicenseSupplementImg"
                error="未上传"
              />
              <ImgReview
                lebal="挂车照片"
                :src="form.trailerVehicleImg"
                error="未上传"
              />
              <ImgReview
                lebal="挂车道路运输证照片"
                :src="form.trailerRoadTransportCertificateImg"
                error="未上传"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </div>
    </el-form>
  </div>
</template>
<script>
import { getVehicle, isTaxOpen } from "@/api/driver";
import ImgReview from "@/components/ImgReview";
export default {
  name: "VehicleDetail",
  components: {
    ImgReview
  },
  props: {
    parentData: {
      type: Object,
      default() {
        return {
          isDetail: false,
          vehicleClassificationList: [],
          vehicleLengthList: [],
          vehicleWidthList: [],
          vehicleHighList: [],
          vehicleTonnageList: [],
          vehicleLicenseColorList: [],
          vehicleEnergyTypeList: []
        };
      }
    }
  },

  data() {
    return {
      showExtra: true,
      otherItems: true,
      linkageInvalid: true,
      isCtmsShow: false,
      hasTaxOpen: false,
      reportProvinceName: "",
      // 必填功能
      checkQuire: false,
      isAdmin: false,
      requireData: {},
      form: {
        roadPermitNumber: "",
        isHasTrailer: 0,
        isLinked: 0
      },
      code: "",
      radioOptions: [{ label: "是", value: 1 }, { label: "否", value: 0 }]
    };
  },
  computed: {
    compTrailer() {
      return this.form.isHasTrailer === 1 ? true : false;
    },
    totalWeight() {
      return this.form.totalWeight;
    }
  },
  created() {
    this.reportProvinceName = this.reportProvince();
    isTaxOpen().then(res => {
      this.hasTaxOpen = res.data;
    });
  },
  methods: {
    getInfo(code) {
      this.form = {};
      getVehicle(code).then(response => {
        response.data.locationSource = response.data.locationSource.toString();
        this.form = response.data;
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.title_box {
  font-weight: bold;
  font-size: 16px;
  color: #333333;
  margin-bottom: 20px;
  width: 100%;
  border-bottom: 2px solid #f2f2f2;
  padding-bottom: 10px;
}
.remars_wrap {
  position: relative;
}
.remarks_position {
  position: absolute;
  bottom: -50px;
}
.m_b_10 {
  margin-bottom: 30px;
}
.el-date-editor {
  width: 100%;
}
.remarks {
  color: #d01415;
  font-size: 10px;
}
::v-deep .dif {
  .el-form-item__content {
    display: flex;
    .el-input {
      flex: 1;
      margin-right: 20px;
    }
    .el-input:last-child {
      margin-right: 0;
    }
  }
}
.mode_box {
  background: #ffffff;
  border-radius: 10px 10px 10px 10px;
  border: 1px solid #f0f3f8;
  margin-top: 45px;
  overflow: hidden;
  margin-bottom: 18px;
  .card_info {
    width: 100%;
    height: 62px;
    line-height: 62px;
    background: #f0f3f8;
    border-radius: 0px 0px 0px 0px;
    font-weight: bold;
    font-size: 18px;
    color: #1169e9;
    padding-left: 15px;
    margin-bottom: 43px;
  }
}
</style>
